import { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import churchillPNG from '~/assets/images/history/history-churchill.png'
import churchillWEBP from '~/assets/images/history/history-churchill.webp'
import { Styles as S } from '~/pages/history/multipleChoice/studyGoal/styles'
import { Styles as BinaryS } from '~/pages/onboarding/quizBinaryChoice/libs/styles'
import { OptionType } from '~/shared/constants/commonConstants'
import { useDelayedContinue } from '~/shared/hooks/useDelayedContinue'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { TPageProps } from '~/shared/types/commonTypes'

const QUESTION = 'How much do you know about Winston Churchill?'

const OPTIONS = [
  { key: 'heardOfHim', i18nKey: 'first' },
  { key: 'knowTheBasics', i18nKey: 'second' },
  { key: 'bigFan', i18nKey: 'third' },
] as const

const Churchill = ({ nextPagePath, pageId }: TPageProps) => {
  const { t } = useTranslation('history')
  const [answer, setAnswer] = useState('')
  const { isAnswersDisabled, handleChange, setIsAnswersDisabled } =
    useDelayedContinue()

  const handleContinue = useNextStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: QUESTION,
  })

  return (
    <BinaryS.Root>
      <BinaryS.StyledContainer>
        <div>
          <BinaryS.Question>
            <Trans ns="history" i18nKey="onboarding.historyChurchill.title" />
          </BinaryS.Question>

          <BinaryS.ImageContainer>
            <picture>
              <source srcSet={churchillWEBP} type="image/webp" />
              <img src={churchillPNG} alt="Winston Churchill" />
            </picture>
          </BinaryS.ImageContainer>
        </div>

        <div>
          {OPTIONS.map(({ key, i18nKey }) => (
            <S.StyledOption
              key={key}
              type={OptionType.RADIO}
              value={key}
              name="churchill"
              disabled={isAnswersDisabled}
              checked={answer === key}
              onChange={(optionValue) => {
                setAnswer(optionValue)
                setIsAnswersDisabled(true)
                handleChange(optionValue, handleContinue)
              }}
            >
              <S.Value>
                <S.ValueText>
                  {t(`onboarding.historyChurchill.options.${i18nKey}`)}
                </S.ValueText>
              </S.Value>
            </S.StyledOption>
          ))}
        </div>
      </BinaryS.StyledContainer>
    </BinaryS.Root>
  )
}

export default Churchill
